module.exports = __webpack_public_path__ + "static/media/people.ca3f936d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/people.svg
// module id = 891
// module chunks = 0